export default function formatDate(date?: string): string | undefined {
  if (!date || date.trim() === "") {
    return undefined;
  }

  return new Date(date).toLocaleDateString("en-US", {
    timeZone: "UTC",
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

export function formatShortDate(date: string): string {
  return new Date(date).toLocaleDateString("en-US", {
    timeZone: "UTC",
  });
}

export function formatISODate(date: Date): string {
  return date.toISOString().split("T")[0];
}
